// extracted by mini-css-extract-plugin
export var contentBody = "_cg-9";
export var headerImage = "_cg-2";
export var imageButton = "_cg-7";
export var imageButtonIcon = "_cg-8";
export var imageHeader = "_cg-4";
export var imageHeaderText = "_cg-5";
export var imageOverlay = "_cg-3";
export var imageTitle = "_cg-6";
export var imageWrapper = "_cg-1";
export var taskList = "_cg-a";
export var widget = "_cg-0";